import { supabase } from "@/services";
import dayjs from "@/lib/locale-dayjs";

export type AppointmentItem = AppointmentTable & {
    users: { first_name: string; last_name: string };
};
export type AppointmentQuery = {
    upcoming: AppointmentItem[];
    today: AppointmentItem[];
    completed: AppointmentItem[];
};
// Define the function to get categorized appointments
export async function getAppointments(
    projectId: string,
): Promise<AppointmentQuery> {
    const now = dayjs();
    const startOfDay = now.startOf("day"); // Start of today
    const endOfDay = now.endOf("day"); // End of today

    // Upcoming Appointments
    const { data: upcoming, error: upcomingError } = await supabase
        .from("appointments")
        .select("*, users (first_name, last_name)")
        .eq("project_id", projectId)
        .eq("status", "Scheduled")
        .gt("appointment_time", now.toISOString()); // Later than now

    if (upcomingError) {
        console.error("Error fetching upcoming appointments:", upcomingError);
    }

    // Today's Appointments
    const { data: today, error: todayError } = await supabase
        .from("appointments")
        .select("*, users (first_name, last_name)")
        .eq("project_id", projectId)
        .eq("status", "Scheduled")
        .gte("appointment_time", startOfDay.toISOString()) // Start of today
        .lte("appointment_time", endOfDay.toISOString()); // End of today

    if (todayError) {
        console.error("Error fetching today's appointments:", todayError);
    }

    // Completed Appointments
    const { data: completed, error: completedError } = await supabase
        .from("appointments")
        .select("*, users (first_name, last_name)")
        .eq("project_id", projectId)
        .eq("status", "Completed");

    if (completedError) {
        console.error("Error fetching completed appointments:", completedError);
    }

    return {
        upcoming: upcoming ?? [],
        today: today ?? [],
        completed: completed ?? [],
    };
}
